import { defineStore } from 'pinia';

import type { IIntegration } from '@/interfaces/agency/integration';
import integrationService from '@/services/agency/integration';

export const useIntegrationStore = defineStore('integrationStore', {
  state: () => ({
    integrations: [] as IIntegration[]
  }),
  getters: {
    getIntegrations(state): IIntegration[] {
      return state.integrations;
    },
    getIntegrationBySlug: state => (slug: string) => {
      // Check for local storage first before fetching from API
      if (!state.integrations.length) {
        const integrations = localStorage.getItem('integrations');

        if (integrations) state.integrations = JSON.parse(integrations);
      }

      return state.integrations.find(integration => integration.slug === slug);
    }
  },
  actions: {
    async fetchIntegrations() {
      const response = await integrationService.getIntegrations();

      this.integrations = response.data;

      localStorage.setItem('integrations', JSON.stringify(response.data));
    }
  }
});
